import React from 'react';
import { IonSpinner } from '@ionic/react';
import Collapsible from 'react-collapsible';
import CollapsibleTrigger from '../UI/CollapsibleTrigger';
import Row from './Row';
import ListBeverage from '../list/Beverage';

export default function MorganaRow(props) {
    const { course, index } = props;
    const [minorCourses, setMinorCourses] = React.useState([]);
    const [isLoading, setLoading] = React.useState(true);
    const [open, setOpen] = React.useState(false);

    async function onOpening() {
        // populate courses with wrappedCourses
        setMinorCourses(course.map(c => c));
        setLoading(false);
    }

    function getMorganaCourseName() {
        if (Number(index) === 0) {
            return ({ name: "cucina" });
        } if (Number(index) === 1) {
            return ({ name: "fine sushi" });
        } if (Number(index) === 2) {
            return ({ name: "dolci" });
        } if (Number(index) === 3) {
            return ({ name: "vini/bevande" });
        }
    }

    return (
        <Collapsible
            className="morgana-row"
            tabIndex={index}
            trigger={<CollapsibleTrigger index={index} trigger={getMorganaCourseName()} setOpen={setOpen} wrapCourse></CollapsibleTrigger>}
            triggerWhenOpen={<CollapsibleTrigger index={index} trigger={getMorganaCourseName()} opened setOpen={setOpen} wrapCourse></CollapsibleTrigger>}
            onTriggerOpening={onOpening}
            open={open}>
            <div>
                {isLoading ?
                    <IonSpinner name="dots" /> :
                    <>
                        {Number(index) !== 3 ?
                            minorCourses.map((minorCourse, index) =>
                                <Row course={minorCourse} index={index} key={index} />
                            )
                            :
                            minorCourses.map((minorCourse, index) => <ListBeverage beverage={minorCourse} index={index} key={index} />)}
                    </>

                }
            </div>
        </Collapsible>
    );
}
